<template>
  <div>
    <b-container fluid class="px-5" v-if="surgery">

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="surgery.name"/>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="bold-text main-color">
          Animal
        </div>
        <div class="mt-2">
          <b-link :to="{ name: 'AnimalShow', params: { animalId: surgery.hospitalization.animal.id }}">
            {{ surgery.hospitalization.animal.name }}
          </b-link>
        </div>
        <div class="mt-4 bold-text main-color">
          Hospitalisation
        </div>
        <div class="mt-2">
          <b-link :to="{ name: 'HospitalizationShow', params: { hospitalizationId: surgery.hospitalization.id }}">
            Hospitalisation du {{new Date(surgery.hospitalization.startDate).toLocaleDateString('fr-FR')}} (#{{surgery.hospitalization.id}})
          </b-link>
        </div>
        <div class="mt-4 bold-text main-color">
          Date
        </div>
        <div class="mt-2">
          {{ new Date(surgery.startDate).toLocaleDateString('fr-FR') }}
        </div>
        <div class="mt-4 bold-text main-color">
          Statut
        </div>
        <div class="mt-2">
          {{ surgery.surgeryStatus.name }}
        </div>
        <div class="mt-4 bold-text main-color">
          Nom
        </div>
        <div class="mt-2">
          {{ surgery.name }}
        </div>
        <div class="mt-4 bold-text main-color">
          Description
        </div>
        <div class="multiline">
          {{ surgery.description ? surgery.description : '-' }}
        </div>
      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <surgery-delete-modal :selected="ui.selectedSurgery" @didDeleteSurgery="didDeleteSurgery()"></surgery-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import ShowActions from "../../components/ShowActions";
import SurgeryDeleteModal from "./SurgeryDeleteModal";

export default {

  name: 'SurgeryShow',

  components: {
    BackArrow,
    ShowActions,
    SurgeryDeleteModal
  },

  data() {
    return {
      surgeryId: this.$route.params.surgeryId,
      surgery: null,
      ui: {
        selectedSurgery: null
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchSurgery()
    },

    fetchSurgery() {
      api
        .get(`/surgery/${this.surgeryId}`)
        .then(response => {
          this.surgery = response.data
        })
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'SurgeryEdit',
        params: {
          surgeryId: this.surgery.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.ui.selectedSurgery = this.surgery
      this.$bvModal.show('surgery-delete-modal')
    },

    didDeleteSurgery() {
      this.ui.selectedCategory = null;
      this.$router.push({
        name: 'SurgeryIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(`Surgery \"${this.surgery.name}\" supprimé`)
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/surgery/SurgeryShow.vue